module.exports = __webpack_public_path__ + "static/media/politica_de_la_empresa.67aeebf2.pdf";